// Get API URL from environment variables
// Fallback to production URL if not specified
export const base_url = 
  process.env.REACT_APP_API_URL || "https://api.shoplintic.in/api/";

